import React from 'react';
import { CheckCircle, Award, Target, Users, Clock, Globe } from 'lucide-react';

export const WhyEduNexa = () => {
  const reasons = [
    {
      icon: CheckCircle,
      title: 'Partnered OSSD School',
      description: 'We work with a fully inspected, Ministry-approved Ontario private school',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: Award,
      title: 'OCT Certified Teachers',
      description: 'All instructors are Ontario Certified Teachers with proven expertise',
      color: 'from-amber-400 to-amber-500'
    },
    {
      icon: Target,
      title: 'Comprehensive Support',
      description: "We'll take care of all your admission and documentation needs, so you and your family can start this journey with confidence and ease.",
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: Clock,
      title: 'Flexible Learning',
      description: 'Study at your own pace with 24/7 access to course materials',
      color: 'from-amber-400 to-amber-500'
    }
  ];

  return (
    <section id="why-edunexa" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold border border-blue-200">Our Advantage</span>
          <h2 className="text-5xl font-bold text-gray-900 mt-4 mb-4">Why Choose <span className="text-amber-500">EduNexa</span>?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Your trusted partner for OSSD success and global university pathways
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-amber-400 hover:shadow-2xl transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="flex-shrink-0 mb-4">
                    <div className={`w-16 h-16 bg-gradient-to-br ${reason.color} rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg`}>
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                      {reason.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center bg-gradient-to-r from-blue-600 via-blue-700 to-blue-600 rounded-3xl p-10 text-white shadow-2xl">
          <h3 className="text-3xl font-bold mb-4">Ready to Start Your OSSD Journey?</h3>
          <p className="text-xl text-blue-100 mb-6 max-w-2xl mx-auto">
            Join thousands of successful students who achieved their university dreams through EduNexa
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-amber-400 hover:bg-amber-500 text-blue-900 px-10 py-4 rounded-xl font-bold text-lg transition-colors shadow-lg"
          >
            Get Started Today
          </button>
        </div>
      </div>
    </section>
  );
};
